import React, { memo } from 'react'
import { MarginType } from 'common/types/styleTypes'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import MobileIconUi from '../styles/ui/MobileIconUi'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

type MarginKeyType = keyof MarginType

export type MarginUpdater = (key: MarginKeyType) => (value: number) => void

type MarginProps = {
  margin: Partial<MarginType>
  update: MarginUpdater
}

function MarginStyle({ margin, update }: MarginProps) {
  const { isMobile } = useDeviceModeContext()

  return (
    <React.Fragment>
      <GroupTitle>settings_styles.margin.label</GroupTitle>
      <RangeElement
        label="settings_styles.margin.top"
        labelIcon={isMobile ? <MobileIconUi /> : null}
        value={margin.marginTop}
        onChange={update('marginTop')}
        max={200}
      />
      <RangeElement
        label="settings_styles.margin.right"
        labelIcon={isMobile ? <MobileIconUi /> : null}
        value={margin.marginRight}
        onChange={update('marginRight')}
        max={200}
      />
      <RangeElement
        label="settings_styles.margin.bottom"
        labelIcon={isMobile ? <MobileIconUi /> : null}
        value={margin.marginBottom}
        onChange={update('marginBottom')}
        max={200}
      />
      <RangeElement
        label="settings_styles.margin.left"
        labelIcon={isMobile ? <MobileIconUi /> : null}
        value={margin.marginLeft}
        onChange={update('marginLeft')}
        max={200}
      />
    </React.Fragment>
  )
}

export default memo(MarginStyle)
